// extracted by mini-css-extract-plugin
export default {"logo_desk":"Logo_logo_desk__prfpC","logo_mobile":"Logo_logo_mobile__G1heL"};